import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <IndexSection />
        <CommentsSection />
        <TopicsSection />
        <AboutSection />
        <FeaturesSection />
        <MediaSection />
        <RankingSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <FaqSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}